import { Component, computed, inject, input } from '@angular/core';
import { CategoryIndicatorService } from 'app/shared/services/category-indicator.service';

@Component({
  selector: 'app-indicator-circle',
  templateUrl: './indicator-circle.component.html',
  styleUrls: ['./indicator-circle.component.scss'],
})
export class IndicatorCircleComponent {
  readonly categoryIndicatorService = inject<CategoryIndicatorService>(CategoryIndicatorService);
  type = input('');
  leaf = input(false);

  readonly color = computed(() => {
    const type = this.type();
    const leaf = this.leaf();
    const { color } = this.categoryIndicatorService.getColorAndIcon(type, leaf);
    return color;
  });
}
